/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Image } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';

import { Text } from 'Component/Ajaib';
import { SkeletonLoad } from 'Component/Skeleton';
import { Icon } from 'Component/Icon';
import { FormatPercentage } from 'Component/NumberFormat';
import { Separator, Pills } from '@ajaibid/components';
import SEARCH_ICON from 'Icon/icon-search.png';

import { onDoRequestNewsStock } from 'Redux/news';
import { onDoRequestStockDiscovery } from 'Redux/stockDiscovery';

import ChevronDropRight from '@assets/Icon/svg/ChevronDropRight';
import PlaceholderImage from '@assets/Image/News/news_img_thumb.png';
import NoNews from '@assets/Icon/icon_newspaper.png';
import stylesGlobal from '../style';
import styles, { NewsItemPills, NewsItemPillsText, NewsItemPillsTextNeutral } from './style';
import useEventTracker from './tracker';

const maxLengthTitle = 90;

const News = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const { eventClickNews, eventSearchNews } = useEventTracker();

  const newsData = useSelector((state) => state.news.newsData);
  const results = newsData?.results || [];
  const hasMore =
    newsData?.count !== null ? newsData?.count > results.length && newsData?.count > 0 : true;
  const isLoading = useSelector((state) => state.news.newsLoading);
  const handleUpdateScrollbars = useCallback((values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 20; // 100px of the bottom
    // t will be greater than 1 if we are about to reach the bottom
    const t = (scrollTop + pad) / (scrollHeight - clientHeight);
    if (t > 1 && hasMore && !isLoading) {
      setPage(page + 1);
    }
  });

  useEffect(() => {
    if (keyword) {
      dispatch(onDoRequestNewsStock(`?q=${keyword}&page=${page}&page_size=20`, page === 1));
    } else {
      dispatch(onDoRequestNewsStock(`?page=${page}&page_size=20`, page === 1));
    }
  }, [page]);

  useEffect(() => {
    const groupCode = 'TopVolumeRG';
    const payload = {
      group_code: groupCode,
      page: 1,
      page_size: 20,
    };
    dispatch(onDoRequestStockDiscovery(payload, groupCode, true));
  }, []);

  const data = useSelector((state) => state.stockDiscovery.stockDiscoveryData);
  let resultsStock = data?.TopVolumeRG?.results || [];
  const dataLoading = useSelector((state) => state.stockDiscovery.stockDiscoveryLoading);
  const isLoadingStock = dataLoading?.TopVolumeRG;

  const onNewsClick = (news) => {
    const eventProps = {
      'entry point': isSearching && keyword !== '' ? 'search recommendation' : 'tab kabar',
      'news id': news?.id,
      'stock ticker': news?.prices?.map((price) => `$${price.code}`).join(', '),
      'news source': news?.source,
    };
    eventClickNews(eventProps);
  };

  if ((isLoadingStock || isLoadingStock === null) && resultsStock.length === 0) {
    return <SkeletonLoad />;
  }
  if (resultsStock.length > 10) resultsStock = resultsStock.slice(0, 10);

  return (
    <Col className="main-container">
      <Text size="h1" bold>
        Berita
      </Text>
      <Row className="mt-24 ml-0 mr-0">
        <Col lg={8} md={8} className="p-0" style={styles.newsGrid}>
          <Row className="ml-0 mr-0 mb-16">
            <Col md={12} className="p-0">
              <div className="d-flex justify-content-between" style={styles.searchInputContainer}>
                <input
                  id="inputSearch"
                  className="form-control shadow-none"
                  type="text"
                  placeholder="Cari kata kunci"
                  style={styles.searchInput}
                  onChange={(v) => {
                    setKeyword(v.target.value);
                  }}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      setPage(1);
                      dispatch(
                        onDoRequestNewsStock(`?q=${keyword}&page=${page}&page_size=20`, page === 1)
                      );
                      setIsSearching(true);
                      eventSearchNews();
                    }
                  }}
                />
                <div className="justify-content-end align-self-center">
                  <Image src={SEARCH_ICON} style={styles.searchIcon} />
                </div>
              </div>
            </Col>
          </Row>
          {!isLoading && (results.length === 0 || (newsData && newsData.count === 0)) ? (
            <Col className="mb-32 mt-32 ml-0 mr-0">
              <Text
                color={stylesGlobal.neutral700}
                className="d-flex justify-content-center"
                style={{ alignItems: 'center' }}
              >
                <div className="mr-8">
                  <Icon src={NoNews} size={24} />
                </div>
                Berita dengan kata kunci &quot;
                {keyword}
                &quot; tidak ditemukan.
              </Text>
            </Col>
          ) : (
            <Scrollbars style={styles.dataContainer} autoHide onUpdate={handleUpdateScrollbars}>
              {results.map((news, idx) => (
                <Fragment key={`news-${idx}`}>
                  <Col
                    lg={12}
                    md={12}
                    style={{ ...{ padding: '16px 12px' } }}
                    className="news-content"
                  >
                    <div className="d-flex justify-content-start align-items-start pb-16">
                      {news.img_url &&
                        (news.img_url ? (
                          <div className="mr-16" style={styles.newImgContainer}>
                            <a
                              href={news.link}
                              target="_blank"
                              rel="noreferrer"
                              onClick={() => onNewsClick(news)}
                            >
                              <Image
                                src={news.img_url.replace('http:', 'https:')}
                                style={styles.newsImage}
                              />
                            </a>
                          </div>
                        ) : (
                          <div className="mr-16" style={styles.newImgContainer}>
                            <a
                              href={news.link}
                              target="_blank"
                              rel="noreferrer"
                              onClick={() => onNewsClick(news)}
                            >
                              <Image src={PlaceholderImage} style={styles.newsImage} />
                            </a>
                          </div>
                        ))}
                      <div className="d-grid">
                        <div>
                          {news.source && (
                            <>
                              <a
                                href={news.link}
                                target="_blank"
                                className="cursor-pointer"
                                style={styles.newsLink}
                                rel="noreferrer"
                                onClick={() => onNewsClick(news)}
                              >
                                <Text color="grey">{news.source}</Text>
                              </a>
                              <Text color="grey" className="pr-4 pl-4">
                                ●
                              </Text>
                            </>
                          )}
                          <Text moment color={stylesGlobal.neutral700}>
                            {news.pub_date}
                          </Text>
                        </div>
                        <div>
                          <a
                            href={news.link}
                            target="_blank"
                            className="cursor-pointer"
                            style={styles.newsLink}
                            rel="noreferrer"
                            onClick={() => onNewsClick(news)}
                          >
                            <Text size="body-bold">
                              {news.title.length > maxLengthTitle
                                ? `${news.title.substr(0, maxLengthTitle).trim()}...`
                                : news.title}
                            </Text>
                          </a>
                        </div>
                        {news.type === 'STOCK' && news.prices.length > 0 && (
                          <div className="d-flex align-items-center mt-16">
                            <div className="mr-4">
                              <ChevronDropRight width={24} height={24} />
                            </div>
                            <div className="d-flex">
                              {news.prices.map((price) => (
                                <Pills
                                  key={`col-price-${news.title}-${price.code}`}
                                  data-key="clickable-item"
                                  className={NewsItemPills}
                                  disabled
                                >
                                  <div
                                    data-key="clickable-item"
                                    className="cursor-pointer"
                                    role="button"
                                    onClick={() => {
                                      navigate(`/home/saham/${price.code}`);
                                      onNewsClick(news);
                                    }}
                                  >
                                    <Text bold className={NewsItemPillsText}>
                                      {price.code}
                                    </Text>{' '}
                                    <Text
                                      bold
                                      className={NewsItemPillsTextNeutral(price.change_pct)}
                                    >
                                      <FormatPercentage value={price.change_pct * 100} />
                                    </Text>
                                  </div>
                                </Pills>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Separator bottom={16} color={stylesGlobal.neutral50} />
                </Fragment>
              ))}
              {hasMore && !isLoading && (
                <div className="text-center">
                  <SkeletonLoad height={100} />
                </div>
              )}
              {isLoading && hasMore && (
                <div className="text-center">
                  <SkeletonLoad height={100} />
                  <SkeletonLoad height={100} top={16} bottom={16} />
                  <SkeletonLoad height={100} top={16} bottom={16} />
                  <SkeletonLoad height={100} top={16} bottom={16} />
                  <SkeletonLoad height={100} top={16} bottom={16} />
                </div>
              )}
            </Scrollbars>
          )}
        </Col>
      </Row>
    </Col>
  );
};

export default News;
